<template>
    <div>
        <div v-if="active" class="modal-complete position-fixed w-100 vh-100">
            <div class="container h-100">
                <div class="row align-items-center justify-content-center h-100">
                    <div class="col-12">
                        <p>
                            You have finished your annual required Fair and Responsible Banking education course. Download your compliance certificate below and retain for your records.
                        </p>
                        <div class="d-flex align-items-center flex-column flex-md-row">
                            <a href="/landing/annual-training/download">Download Certificate</a>
                            <a href="javascript:void(0)" @click="active = false" class="btn-primary ml-md-3 mt-3 mt-md-0">Continue to the site</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VideoModal from '@/components/VideoModal.vue';
import eventBus from '@/event-bus';
import AnnualTrainingService from '@/services/annual-training.service';

export default {
    components: {
        VideoModal
    },
    props: {
        requiredTrainingVideos: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            active: false,
            videos: []
        }
    },
    mounted() {
        eventBus.$on('videoEnded', this.videoEnded);
    },
    watch: {
        active(newValue) {
            const el = document.body;

            if (newValue) {
                el.classList.add('overflow-hidden');
            } else {
                el.classList.remove('overflow-hidden');
            }
        }
    },
    methods: {
        async videoEnded(event) {
            if (this.requiredTrainingVideos.includes(event.videoId)) {
                const videos = this.requiredTrainingVideos.filter(videoId => videoId !== event.videoId);

                if (!videos.length) {
                    this.active = true;

                    try {
                        await AnnualTrainingService.store();

                        this.success = true;
                    } catch (error) {
                        this.handleError(error);
                    } finally {
                        this.pending = false;
                    }
                }
            }
        }
    }
}
</script>

<style lang="scss">
.modal-complete {
    left: 0;
    top: 0;
    background: #ffffff;
    z-index: 10;
}
</style>
